import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {HistoryDetailPage} from './history-detail/HistoryDetailPage'
import {HistoryList} from './history-list/HistoryList'

const HistoryPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/list'
          element={
            <>
              <HistoryList />
            </>
          }
        />
        <Route
          path='/:id/detail'
          element={
            <>
              <HistoryDetailPage />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/history/list' />} />
    </Routes>
  )
}

export default HistoryPage
